var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5961 0.672579L0.446004 11.8227C0.199683 12.069 0.336965 12.6056 0.752631 13.0213C1.1683 13.437 1.70495 13.5743 1.95127 13.3279L13.1014 2.17784C13.3477 1.93152 13.2104 1.39487 12.7947 0.979207C12.3791 0.56354 11.8424 0.426258 11.5961 0.672579Z",
    fill: "#0A1E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.38 21.8787L2.48054 11.9792C2.09002 11.5886 1.45686 11.5886 1.06633 11.9792C0.675806 12.3697 0.675806 13.0029 1.06633 13.3934L10.9658 23.2929C11.3564 23.6834 11.9895 23.6834 12.38 23.2929C12.7706 22.9024 12.7706 22.2692 12.38 21.8787Z",
    fill: "#0A1E5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7739 11.636H1.77393C1.22164 11.636 0.773926 12.0837 0.773926 12.636C0.773926 13.1883 1.22164 13.636 1.77393 13.636H26.7739C27.3262 13.636 27.7739 13.1883 27.7739 12.636C27.7739 12.0837 27.3262 11.636 26.7739 11.636Z",
    fill: "#0A1E5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b3fcfaa4f0957e2af85da75a7890a184.svg";
export { ForwardRef as ReactComponent };